module.exports = __webpack_public_path__ + "static/img/m-erm.05c622d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m-erm.jpg
// module id = 213
// module chunks = 1 5